import React from 'react';
import { Link } from "react-router-dom";

const BackofficePortfolioLink = ({portfolioUuid, profileUuid, children}: {portfolioUuid: string, profileUuid?: string, children: any}) => {
    return (
        <Link to={`/dashboard/clients/${profileUuid}/${portfolioUuid}/tabs`}>
            {children}
        </Link>
    );
};

export default BackofficePortfolioLink;